import { create } from 'zustand';

type AuthStatus = 'idle' | 'loading' | 'pending_approval' | 'approved' | 'error';
type UserRole = 'owner' | 'admin';

interface AuthState {
  status: AuthStatus;
  userId: string | null;
  token: string | null;
  role: UserRole | null;
  needsOnboarding: boolean;
  error: string | null;

  setAuth(
    token: string,
    userId: string,
    isApproved: boolean,
    needsOnboarding: boolean,
    role?: UserRole
  ): void;
  setLoading(): void;
  setError(message: string): void;
  reset(): void;
  completeOnboarding(): void;
}

export const useAuthStore = create<AuthState>((set) => ({
  status: 'idle',
  userId: null,
  token: null,
  role: null,
  needsOnboarding: false,
  error: null,

  setAuth(token, userId, isApproved, needsOnboarding, role) {
    localStorage.setItem('auth_token', token);
    set({
      token,
      userId,
      role: role ?? null,
      needsOnboarding,
      status: isApproved ? 'approved' : 'pending_approval',
      error: null,
    });
  },

  setLoading() {
    set({ status: 'loading', error: null });
  },

  setError(message) {
    set({ status: 'error', error: message });
  },

  reset() {
    localStorage.removeItem('auth_token');
    set({
      status: 'idle',
      userId: null,
      token: null,
      role: null,
      needsOnboarding: false,
      error: null,
    });
  },

  completeOnboarding() {
    set({ needsOnboarding: false });
  },
}));
